import { IsOperatorState } from './types';

export const initialState: IsOperatorState = null;

export function isOperator(state: IsOperatorState = initialState) {
  return state;
}
